//-- Copyright (c) 2021 TMT Insights Group, LLC
import { Redirect, Route, useLocation } from 'react-router-dom';
import Layout from '../../layout/Layout/Layout';
import { PolarisRoute } from '@/view/polarisRoutes';

type PublicPageProps = {
  configOptions: { key: string; label: string }[];
  path: PolarisRoute['path'];
  component: any;
  exact?: PolarisRoute['exact'];
  role?: PolarisRoute['role'];
  ignoreScrollBehavior: PolarisRoute['ignoreScrollBehavior'];
};

function PublicPage({ configOptions, path, component: Component, ...rest }: PublicPageProps) {
  const location = useLocation();
  const notFound = path === '*';

  return (
    <Route
      {...rest}
      render={(props) => {
        if (notFound) {
          return <Redirect to={{ pathname: '/page-not-found', state: { from: location } }} />;
        }
        return (
          <Layout {...props} configOptions={configOptions}>
            <Component {...props} />
          </Layout>
        );
      }}
    />
  );
}
export default PublicPage;
